/* RESPONSIBLE TEAM: team-data-foundations */

export function isSalesforceSandboxUrl(url: string): boolean {
  if (!url) {
    return false;
  }

  try {
    let urlObj = new URL(url);
    let host = urlObj.hostname.toLowerCase();

    if (host.includes('test.salesforce.com')) {
      return true;
    }
    if (host.includes('.sandbox.my.salesforce.com')) {
      return true;
    }
    if (host.includes('--')) {
      return true;
    }
    if (host.startsWith('cs')) {
      return true;
    }

    return false;
  } catch {
    return false;
  }
}
